import * as Sentry from "@sentry/nextjs"
import { observable, runInAction } from "mobx"

import { fetchGetCompanyById } from "~/api/companies/[id]/get"
import { fetchGetCompaniesRecruitment } from "~/api/companies/[id]/recruitment/get"
import { fetchGetCompanies } from "~/api/companies/get"
import { Company } from "~/entities/Company"
import { Event } from "~/entities/Event"
import { LongInternship, createLongInternshipArgs } from "~/entities/LongInternship"
import { NewGradJob } from "~/entities/NewGradJob"
import { ShortInternship } from "~/entities/ShortInternship"

export default class CompanyStore {
  @observable company: Company | null = null
  @observable companies: Array<Company> = []
  @observable newGradJobs: Array<NewGradJob> = []
  @observable shortInternships: Array<ShortInternship> = []
  @observable longInternships: Array<LongInternship> = []
  @observable events: Array<Event> = []

  fetch = async (number?: number): Promise<Company[]> => {
    const companies = await fetchGetCompanies()
    const data = (Array.isArray(companies) ? companies : []).map((datum: any) => {
      return new Company(datum)
    })
    runInAction(() => {
      this.companies = data
    })
    return number === undefined ? this.companies : this.companies.slice(0, number)
  }

  fetchById = async (id: number): Promise<Company | null> => {
    const data = await fetchGetCompanyById(id)
    runInAction(() => {
      this.company = new Company(data as any)
    })
    return this.company
  }

  // 企業に紐づく全ての募集を取得する（企業ページの「募集」タブで使う）
  fetchAllRecruitments = async (id: number) => {
    const data = await fetchGetCompaniesRecruitment(id)
    runInAction(() => {
      data.new_grad_jobs.map((datum) => {
        // この3つはレスポンスを見る限り使ってなさそう、、
        this.newGradJobs.push(new NewGradJob(datum as any))
      })
      data.short_internships.map((datum) => {
        // この3つはレスポンスを見る限り使ってなさそう、、
        this.shortInternships.push(new ShortInternship(datum as any))
      })
      data.long_internships.map((datum) => {
        this.longInternships.push(new LongInternship(datum as unknown as createLongInternshipArgs))
      })
      data.events.map((datum) => {
        // この3つはレスポンスを見る限り使ってなさそう、、
        this.events.push(new Event(datum as any))
      })
    })
    return true
  }
}
